import moment from 'moment'
import 'moment-timezone'

export default [
    {
        title: 'Vancouver',
        title_pt: 'Vancouver',
        title_es: 'Vancouver',
        slug: 'ca',
        img: require('../assets/bandeiras/can.png'),
        timezone: 'America/Vancouver',
        date: moment()
            .tz('America/Vancouver')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: true,
        select: false
    },
    {
        title: 'New York',
        title_pt: 'Nova York',
        title_es: 'Nueva York',
        slug: 'us',
        img: require('../assets/bandeiras/usa.png'),
        timezone: 'America/New_York',
        date: moment()
            .tz('America/New_York')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: true,
        select: true
    },
    /* {
        title: 'Bauru',
        title_pt: 'Bauru',
        title_es: 'Bauru',
        slug: 'br_sp',
        img: require('../assets/flags/small/samerica/bra.png'),
        timezone: 'America/Sao_Paulo',
        date: moment()
            .tz('America/Sao_Paulo')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: false,
        select: false,
        new: true,
        //breve: true
    }, */
    {
        title: 'London',
        title_pt: 'Londres',
        title_es: 'Londres',
        slug: 'gb',
        img: require('../assets/bandeiras/ing.png'),
        timezone: 'Europe/London',
        date: moment()
            .tz('Europe/London')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: true,
        select: false
    },
    {
        title: 'Singapur',
        title_pt: 'Singapura',
        title_es: 'Singapur',
        slug: 'sg',
        img: require('../assets/bandeiras/sin.png'),
        timezone: 'Asia/Singapore',
        date: moment()
            .tz('Asia/Singapore')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: true,
        select: false
    },
    /* {
      title: 'Taipei',
      title_pt: 'Taipei',
      title_es: 'Taipéi',
      slug: 'tw',
      img: require('../assets/flags/small/asia/bur.png'),
      timezone: 'Asia/Taipei',
      date: moment()
        .tz('Asia/Taipei')
        .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
      status: true,
      select: false,
      new: false,
      breve: true
    }, */
    {
        title: 'Sydney',
        title_pt: 'Sydney',
        title_es: 'Sydney',
        slug: 'au',
        img: require('../assets/bandeiras/aus.png'),
        timezone: 'Australia/Sydney',
        date: moment()
            .tz('Australia/Sydney')
            .format('HH:mm:ss ‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎ ‏‏‎‎DD/MM/YY'),
        status: true,
        select: false
    }
]
